export const CoreLightPalette: any = {
    0: '#515B69',
    1: '#FE67A3',
    2: '#FE67A3',
    3: '#DE35C1',
    4: '#7F5AF2',
    5: '#7F5AF2',
    6: '#66C9F9',
    7: '#66C9F9',
    8: '#66C9F9',
    9: '#65DED0',
    10: '#7BDB94',
    11: '#7BDB94',
    12: '#7BDB94',
    13: '#65DED0',
    14: '#F5CF5B',
    15: '#FFAB66',
    16: '#FF7E75',
    17: '#515B69',
    18: '#515B69',
    19: '#B57A5C',
    20: '#7098FF',
    21: '#7098FF',
    22: '#7F5AF2',
    23: '#515B69',
    24: '#7F5AF2',
    25: '#515B69',
    26: '#FE67A3',
    27: '#6981FE',
    28: '#69E4F5',
    29: '#8BF6C3',
    30: '#5EBC83',
    31: '#C2E872',
    32: '#F06462',
    33: '#FF8BD1',
    34: '#C269D1',
    35: '#A154CF',
    36: '#8C6BD2',
    37: '#C17E7E',
    38: '#937E7E',
}

export const CoreLightBorderPalette: any = {
    0: '#6F7B90',
    1: '#F95395',
    2: '#F95395',
    3: '#E057C9',
    4: '#9271F4',
    5: '#9271F4',
    6: '#36B5F2',
    7: '#36B5F2',
    8: '#36B5F2',
    9: '#49D0C0',
    10: '#62D07F',
    11: '#62D07F',
    12: '#62D07F',
    13: '#49D0C0',
    14: '#F4CA48',
    15: '#FCA055',
    16: '#F56E66',
    17: '#6F7B90',
    18: '#6F7B90',
    19: '#B8886F',
    20: '#5D89F8',
    21: '#5D89F8',
    22: '#9271F4',
    23: '#6F7B90',
    24: '#9271F4',
    25: '#6F7B90',
    26: '#F95395',
    27: '#4F68EE',
    28: '#40CFE2',
    29: '#6FE5AF',
    30: '#4EA973',
    31: '#A9D155',
    32: '#DA5C5A',
    33: '#E96AB7',
    34: '#AB4BBA',
    35: '#8A44B5',
    36: '#7A5BBA',
    37: '#AA6666',
    38: '#7D6464',
}